import styled from "styled-components"

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.mainAxis || "flex-start"};
    align-items: ${props => props.crossAxis || "flex-start"};
`;

export default Row;